import { IWorkOrder } from '../models';

// UK and Canada number a job created from work orders after the work order itself.
// Mirrors constants.ukCountryID / constants.caCountryID — inlined so this pure
// leaf util stays free of the heavy constants module (which boots MSAL on load).
const UK_COUNTRY_ID = '419ec375-dce2-41fb-8251-ce28caa507f5';
const CA_COUNTRY_ID = '2fcbfdc4-9c25-4b58-874c-7c2625eaa750';
const workOrderJobNumberCountryIDs: string[] = [UK_COUNTRY_ID, CA_COUNTRY_ID];

/**
 * The job number to prefill when creating a job from work orders.
 * UK and Canada facilities use the first selected work order's number, everyone else the next auto number.
 */
export const getDefaultJobNumber = (
    countryID: string | undefined,
    workOrders: Array<IWorkOrder | undefined>,
    nextJobNumber: string
): string => {
    if (!countryID || !workOrderJobNumberCountryIDs.includes(countryID)) {
        return nextJobNumber;
    }
    const numberedWorkOrder = workOrders.find(wo => wo?.number);
    return numberedWorkOrder?.number || nextJobNumber;
};
